import * as React from "react";
import styled from "styled-components";
import { Label } from "components/bootstrap";
import { Tooltip } from "components/common";
import { DISABLED_MODEL_PROVIDER_EXPLANATION } from "ai-management/model-providers/Constants";
const StyledLabel = styled(Label)`
  margin-left: 5px;
  vertical-align: inherit;
`;
const DisabledLabel = () => /* @__PURE__ */ React.createElement(Tooltip, { label: DISABLED_MODEL_PROVIDER_EXPLANATION, position: "top", multiline: true, w: 300 }, /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(StyledLabel, { bsStyle: "warning", bsSize: "xsmall" }, "Disabled")));
export default DisabledLabel;
